/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';
import * as cdsIcons from '@coursera/cds-icons';

import Markdown from 'bundles/cms/components/Markdown';

// iconsMap is not React component
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { iconsMap, ...icons } = cdsIcons;

export type CareerStat = {
  icon?: string | null;
  description?: string | null;
};

type Props = { careerStats: CareerStat[] };

const styles = {
  container: () => css`
    border-radius: 8px;
    border: 1px solid var(--cds-color-grey-50);
    background: var(--cds-color-neutral-background-primary);
    padding: var(--cds-spacing-300) 0;
    position: absolute;
    transform: translateY(50%);
    bottom: 0;
    margin: 0 auto;
    text-align: center;
    align-items: center;
    display: flex;
    ${breakpoints.up('lg')} {
      width: 700px;
    }
    ${breakpoints.down('md')} {
      width: 50%;
    }
    ${breakpoints.down('sm')} {
      width: 90%;
    }
    ${breakpoints.down('xs')} {
      flex-direction: column;
      padding: 0 var(--cds-spacing-300);
      align-items: unset;
      text-align: left;
    }
  `,
  stat: (theme: Theme) => css`
    flex: 1;
    ${breakpoints.down('xs')} {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: var(--cds-spacing-300) 0;
    }

    & + & {
      border-left: 1px solid var(--cds-color-grey-50);
      ${breakpoints.down('xs')} {
        border-left: none;
        border-top: 1px solid var(--cds-color-grey-50);
      }
    }

    .rc-Markdown.styled {
      p {
        margin-bottom: 0;
      }

      strong {
        ${theme.typography.h2semibold}
        display: block;
      }
    }
  `,
};

const RolePageHeroCareerStats = ({ careerStats }: Props) => {
  if (!careerStats?.length) {
    return null;
  }
  return (
    <div css={styles.container}>
      {careerStats.map((careerStat, index) => {
        const Icon = careerStat.icon && icons[careerStat.icon as keyof typeof icons];
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div css={styles.stat} key={index}>
            {Icon && <Icon size="large" />}
            <Markdown source={careerStat.description} />
          </div>
        );
      })}
    </div>
  );
};

export default RolePageHeroCareerStats;
